{
    "TermsAndConditions_Title": "Geschäftsbedingungen",
    "TermsAndConditions_Subtitle": "Die Nutzungsbedingungen der Anwendung sind unten aufgeführt. Bitte bestätigen Sie Ihre Zustimmung, indem Sie „Ich stimme den Nutzungsbedingungen zu“ aktivieren und anschließend auf „Akzeptieren“ klicken.",
    "TermsAndConditions_Subtitle_NoAccept": "Unsere Standard-Servicebedingungen sind unten aufgeführt.",
    "TermsAndConditions_AcceptText": "Ich stimme den Bedingungen und Konditionen zu",
    "TermsAndConditions_AcceptButton": "Akzeptieren",
    "TermsAndConditions_CloseButton": "Schließen",
    "NAME": "TermsAndConditions"
}